<template>
  <div class="Content">
    <div class="Title">
      Редактирование курса
    </div>
    <div class="TypeInfo">
      Основная информация о курсе
    </div>
    <div class="Info">
      <DefaultInput
        v-model="course.data.name"
        @update:modelStatus="course.validate.name = $event"
        placeholder="Название"
        :isNull="false"
      />
      <DefaultTextarea
        v-model="course.data.description"
        placeholder="Расскажите, чему научит курс, как он проходит и какие темы охватывает"
        :maxLength=350
      />
      <DefaultTextarea
        v-model="course.data.forWhom"
        placeholder="Опишите, для кого создан курс. Например: начинающие бухгалтера, ИП, студенты"
        :maxLength=350
      />
      <DefaultInput
        v-model="course.data.dateStart"
        @update:modelStatus="course.validate.dateStart = $event"
        placeholder="Дата старта нового потока"
        type="date"
        :isNull="false"
      />
      <DefaultCheckbox
        v-model="course.data.trialSession"
        label="Есть бесплатное пробное занятие"
      />
    </div>
    <div class="TypeInfo">
      Как проходит обучение
    </div>
    <div class="Info">
      <CustomSelect
        v-model="course.data.lang"
        :options="langs"
        placeholder="Язык*"
      />
      <CustomSelect
        v-model="course.data.trainFormat"
        :options="formats"
        placeholder="Формат занятий*"
      />
      <DefaultInput
        v-model="course.data.courseDuration"
        @update:modelStatus="course.validate.courseDuration = $event"
        placeholder="Длительность курса (в месяцах)"
        type="float"
        :isNull="false"
        :maxLength="4"
      />
      <DefaultInput
        v-model="course.data.lessonDuration"
        @update:modelStatus="course.validate.lessonDuration = $event"
        placeholder="Продолжительность одного занятия (в минутах)"
        type="number"
        :isNull="false"
      />
      <!--<DefaultFileInput
        v-model="course.data.courseProgramFile"
        :uploadUrl="course.data.courseProgramUrl"
        label="Программа курса"
      />-->
    </div>
    <div class="TypeInfo">
      Программа курса
    </div>
    <div class="Info">
      <div
        class="Module"
        v-for="(module, index) in courseModulesByOrder"
        :key="module._id"
      >
        <div class="ModuleActions">
          <div 
            v-show="index+1 < courseModulesByOrder.length" 
            class="Action" 
            @click="changeOrder('down', index, courseModulesByOrder)"
          >
            <img
              src="./../../../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
              alt=""
            />
          </div>
          <div 
            v-show="index > 0" 
            class="Action" 
            @click="changeOrder('up', index, courseModulesByOrder)"
          >
            <img
              style="transform: rotate(180deg);"
              src="./../../../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
              alt=""
            />
          </div>
          <div 
            v-show="courseModulesByOrder.length > 1" 
            class="Action" 
            @click="deleteElementRecalcOrder(index, courseModulesByOrder)"
          >
            <img
              style="width: 20px; height: 20px"
              src="./../../../../assets/img/ReDesign/interface_icons/close_modal_16px.svg"
              alt=""
            />
          </div>
        </div>
        <DefaultInput
          v-model="module.name"
          @update:modelStatus="module._validate.name = $event"
          label="Название модуля"
          :isNull="false"
        />
        <DefaultTextarea
          v-model="module.desc"
          @update:contentRaw="module.descRaw = $event"
          @update:modelStatus="module._validate.desc = $event"
          label="Описание модуля"
          :maxLength=3000
          type="vuequill"
        />
      </div>
      <button
        class="btn-n-white AddButton"
        @click="addModule()"
      >
        Добавить модуль
      </button>
    </div>
    <div class="TypeInfo">
      Преподаватели
    </div>
    <div class="Info">
      <div
        class="Module"
        v-for="(teacher, index) in courseTeachersByOrder"
        :key="teacher._id"
      >
        <div class="ModuleActions">
          <div v-show="index+1 < courseTeachersByOrder.length" class="Action" @click="changeOrder('down', index, courseTeachersByOrder)">
            <img
              src="./../../../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
              alt=""
            />
          </div>
          <div v-show="index > 0" class="Action" @click="changeOrder('up', index, courseTeachersByOrder)">
            <img
              style="transform: rotate(180deg);"
              src="./../../../../assets/img/ReDesign/interface_icons/arrow_down_black_16px.svg"
              alt=""
            />
          </div>
          <div 
            v-show="courseTeachersByOrder.length > 1" 
            class="Action" 
            @click="deleteElementRecalcOrder(index, courseTeachersByOrder)"
          >
            <img
              style="width: 20px; height: 20px"
              src="./../../../../assets/img/ReDesign/interface_icons/close_modal_16px.svg"
              alt=""
            />
          </div>
        </div>
        <DefaultFileInput
          v-model="teacher.avatarDataUrl"
          :uploadUrl="teacher.avatar"
          label="Прикрепите фотографию преподавателя или загрузите её"
          type="avatar"
        />
        <DefaultInput
          v-model="teacher.name"
          @update:modelStatus="teacher._validate.name = $event"
          label="Полное имя преподавателя"
          type="fio"
          :isNull="false"
        />
        <DefaultTextarea
          v-model="teacher.desc"
          @update:modelStatus="teacher._validate.desc = $event"
          label="Описание преподавателя"
          :maxLength=3000
        />
      </div>
      <button
        class="btn-n-white AddButton"
        @click="addTeacher()"
      >
        Добавить преподавателя
      </button>
    </div>
    <div class="TypeInfo">
      Сертификация
    </div>
    <div class="Info">
      <DefaultCheckbox
        v-model="course.data.homework"
        label="Домашние задания"
      />
      <DefaultCheckbox
        v-model="course.data.finalExam"
        label="Итоговый экзамен"
      />
    </div>
    <div class="TypeInfo">
      Оплата
    </div>
    <div class="Info">
      <DefaultInput
        v-model="course.data.price"
        @update:modelStatus="course.validate.price = $event"
        placeholder="Стоимость"
        type="price"
        :isNull="false"
      />
    </div>
    <div class="TypeInfo">
      Состояние курса
    </div>
    <div class="Info">
      <DefaultCheckbox
        v-model="course.data.isVisible"
        label="Показывать ли курс клиентам"
      />
    </div>
    <div class="Buttons">
      <button
        :class="validateSuccess ? 'btn-n-yellow' : 'btn-n-yellow-disabled'"
        style="width: 231px; height: 48px; font-size: 16px"
        @click="updateCourse()"
      >
        Сохранить и вернуться
      </button>
      <button
        class="btn-n-white"
        style="width: 176px; height: 48px; font-size: 16px"
        @click="back()"
      >
        Вернуться назад
    </button>
    </div>
  </div>
</template>

<script>
import DefaultInput from "@/components/OctaUI/Inputs/DefaultInput.vue";
import CustomSelect from "@/components/OctaUI/Selects/CustomSelect.vue";
import DefaultFileInput from "@/components/OctaUI/Inputs/DefaultFileInput.vue";
import DefaultTextarea from "@/components/OctaUI/Inputs/DefaultTextarea.vue";
import DefaultCheckbox from "@/components/OctaUI/Selects/DefaultCheckbox.vue";

import { ElNotification } from "element-plus";
import { getJobByID, updateJob, updateJobIsVisible } from "@/api/job.js";
import { dataURLtoFile } from "@/utils/dataURLtoFile.js";

import "@/assets/css/Repainting/Buttons.css";

export default {
  components: {
    DefaultInput,
    CustomSelect,
    DefaultFileInput,
    DefaultTextarea,
    DefaultCheckbox
  },
  data() {
    return {
      // Заполняемая информация о курсе
      course: {
        request: {
          getInfo: false
        },
        data: {
          id: null,
          name: null,
          description: null,
          forWhom: null,
          dateStart: null,
          trialSession: false,
          lang: null,
          trainFormat: null,
          courseDuration: null,
          lessonDuration: null,
          courseProgramUrl: null,
          courseProgramFile: null,
          homework: false,
          finalExam: false,
          price: null,
          isVisible: false,
          modules: [],
          teachers: []
        },
        validate: {
          name: false,
          dateStart: false,
          courseDuration: false,
          lessonDuration: false,
          price: false
        },
      },

      // Данные для селекторов
      langs: [
        { value: 3, name: "Oʻzbekcha" },
        { value: 1, name: "Русский" },
      ],
      formats: [
        { value: "tables.jobs.train_format.online", name: "tables.jobs.train_format.online" },
        { value: "tables.jobs.train_format.offline", name: "tables.jobs.train_format.offline" },
        { value: "tables.jobs.train_format.hybrid", name: "tables.jobs.train_format.hybrid" },
      ],

      // Сообщения
      msg: {
        title: {
          updateJob: "Курс успешно обновлен",
          createError: "Извините, произошла ошибка создания",
          serverError: "Извините, произошла ошибка на сервере",
        },
        form: {
          success: {
            title: "Успех!",
            type: "success",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
          error: {
            title: "Упс!",
            type: "error",
            position: "bottom-right",
            customClass: "ELDefaultNotification",
          },
        },
      },
    };
  },
  computed: {
    // Сортируем модули по Order
    courseModulesByOrder() {
      return this.course.data.modules.sort((a, b) => a.order - b.order);
    },
    // Сортируем учителей по Order
    courseTeachersByOrder() {
      return this.course.data.teachers.sort((a, b) => a.order - b.order);
    },
    validateSuccess() {
      return (
        this.course.validate.name &&
        this.course.validate.dateStart &&
        this.course.validate.courseDuration &&
        this.course.validate.lessonDuration &&
        this.course.validate.price &&
        this.course.data.lang &&
        this.course.data.trainFormat &&
        this.course.data.modules.every(item => item._validate.name) &&
        this.course.data.modules.every(item => item._validate.desc) &&
        this.course.data.teachers.every(item => item._validate.name) &&
        this.course.data.teachers.every(item => item._validate.desc)
      );
    },
  },
  mounted() {
    this.getCourse();
  },
  methods: {
    // Обновляем информацию о курсе
    async updateCourse() {
      try {
        let textData = {
          name: this.course.data.name,
          description: this.course.data.description,
          forWhom: this.course.data.forWhom,
          dateStart: this.parseDate(this.course.data.dateStart),
          trialSession: this.course.data.trialSession,
          lang: this.course.data.lang,
          trainFormat: this.course.data.trainFormat,
          courseDuration: Number(this.course.data.courseDuration),
          lessonDuration: this.course.data.lessonDuration,
          homework: this.course.data.homework,
          finalExam: this.course.data.finalExam,
          price: this.course.data.price.replace(/\s/g, ''),
          _needUpdateStatus: false, // Сообщаем о том, что не нужно автоматически обновлять статус
          job_modules: this.course.data.modules,
          course_teachers: this.course.data.teachers
        };

        let formData = new FormData();
        formData.append("req_data", JSON.stringify(textData));

        for (const teacher of this.course.data.teachers) {
          const file = dataURLtoFile(teacher.avatarDataUrl, "avatar_teacher.png");
          formData.append(
            `course_teachers_avatars[${teacher.order-1}]`,
            file
          );
        }

        const result = await updateJob(this.course.data.id, formData);

        const resultUpdateIsVisible = await updateJobIsVisible(
          this.course.data.id, 
          { isVisible: this.course.data.isVisible }
        );

        if (result.status === 200) {
          ElNotification({
            ...this.msg.form.success,
            message: this.msg.title.updateJob,
          });
        } else {
          ElNotification({
            ...this.msg.form.error,
            message: this.msg.title.createError,
          });
        }
      } catch (e) {
        console.log(e);
        ElNotification({
          ...this.msg.form.error,
          message: this.msg.title.serverError,
        });
      }
      
      // Возвращаемся на страницу, с которой пришли со сохранением состояния
      this.$router.go(-1);
    },

    // Получаем курс по его id из route
    async getCourse() {
      try {
        // Если courseId передан в route и не пустой 
        if (
          this.$route.query?.courseId != null &&
          this.$route.query?.courseId != ""
        ) {
          this.course.data.id = parseInt(this.$route.query?.courseId);
          const courseRequest = await getJobByID(this.course.data.id);

          // Если запрос удачен и курс найден, то записываем информацию о нем
          if(courseRequest.status === 200 && courseRequest.data?.id) {
            const data = courseRequest.data;

            this.course.data.id = data.id;
            this.course.data.name = data.name;
            this.course.data.description = data.description;
            this.course.data.forWhom = data.forWhom;
            this.course.data.dateStart = this.normalDate(data.dateStart);
            this.course.data.trialSession = data.trialSession;
            this.course.data.lang = data.lang;
            this.course.data.trainFormat = data.trainFormat;
            this.course.data.courseDuration = String(data.courseDuration);
            this.course.data.lessonDuration = data.lessonDuration;
            this.course.data.courseProgramUrl = data.course_program_url;
            this.course.data.homework = data.homework;
            this.course.data.finalExam = data.finalExam;

            // Если цена задана, то переводим её в строку для наложения маски
            if (data.price) {
              this.course.data.price = this.textPrice(data.price);
            }
            this.course.data.isVisible = data.isVisible;

            // Получаем массив модулей и добавляем в него validate, если массив пуст, добавляем в него один пустой объект модуля
            if (data.job_modules?.length > 0) {
              for(const module of data.job_modules) {
                module._validate = { name: false, desc: false };
                module._id = Date.now(); // Уникальный id для сортировки
              }
              this.course.data.modules = Array.from(data.job_modules);
            }
            else {
              this.course.data.modules = [{ 
                id: null, name: null, desc: '', descRaw: '', order: 1, courseId: data.id,
                _validate: {
                  name: false,
                  desc: false
                },
                _id: Date.now() // Уникальный id для сортировки
              }];
            }

            // Получаем массив преподавателей и добавляем в него validate, 
            // если массив пуст, добавляем в него один пустой объект преподавателя
            if (data.course_teachers?.length > 0) {
              for(const teacher of data.course_teachers) {
                teacher._validate = { name: false, desc: false };
                teacher._id = Date.now(); // Уникальный id для сортировки
              }
              this.course.data.teachers = Array.from(data.course_teachers);
            }
            else {
              this.course.data.teachers = [{ 
                id: null, name: null, desc: '', order: 1, courseId: data.id, avatarDataUrl: null, avatar: null,
                _validate: {
                  name: false,
                  desc: false
                },
                _id: Date.now() // Уникальный id для сортировки
              }];
            }

            // Сообщаем о том, что информация о курсе получена
            this.course.request.getInfo = true;
          }
        }
      } catch (e) {
        console.log(e);
      }
    },

    // Меняем местами модули по order
    changeOrder(direct, index, array) {
      // Сохраняем скролл(чтобы не прыгал)
      const scrollY = window.scrollY;

      // Поднимаем модуль вверх на 1 ячейку
      if (direct === 'up') {
        // Если модуль уже и так в самом верху - ничего не делаем
        if (index === 0) return;

        array[index].order--;
        array[index-1].order++;
      }
      // Опускаем модуль вниз на 1 ячейку
      if (direct === 'down') {
        // Если модуль уже и так в самом низу - ничего не делаем
        if (index === array.length - 1) return;

        array[index].order++;
        array[index+1].order--;
      }

      // Восстанавливаем скролл
      this.$nextTick(() => {
        window.scrollTo(0, scrollY);
      });
    },

    // Добавляем модуль в массив
    addModule() {
      this.course.data.modules.push({ 
        id: null, name: null, desc: '', descRaw: '', order: this.course.data.modules.length + 1, courseId: this.course.data.id,
        _validate: {
          name: false,
          desc: false
        },
        _id: Date.now() // Уникальный id для сортировки
      });
    },

    // Добавляем преподавателя в массив
    addTeacher() {
      this.course.data.teachers.push({ 
        id: null, 
        name: null, 
        desc: '', 
        order: this.course.data.teachers.length + 1, 
        courseId: this.course.data.id, 
        avatarDataUrl: null,
        avatar: null,
        _validate: {
          name: false,
          desc: false
        },
        _id: Date.now() // Уникальный id для сортировки
      });
    },

    // Удаляем элемент из массива и пересчитываем order
    deleteElementRecalcOrder(index, array) {
      array.splice(index, 1);

      array.forEach((element, index) => {
        element.order = index + 1;
      });
    },

    // Приводим объект даты Date к виду XX.XX.XXXX
    normalDate(date) {
      const newDate = new Date(date);
      const day = String(newDate.getDate()).padStart(2, "0");
      const month = String(newDate.getMonth() + 1).padStart(2, "0");
      const year = newDate.getFullYear();

      return `${day}.${month}.${year}`;
    },

    // Переводим XX.XX.XXXX вид даты в объект Date
    parseDate(date) {
      const parts = date.split('.');

      const day = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1; // Месяцы в Date от 0 до 11
      const year = parseInt(parts[2], 10);
      
      return new Date(year, month, day);
    },

    textPrice(price) {
      return String(price).split('').reverse().join('')
        .replace(/(.{3})/g, '$1 ')
        .trim()
        .split('').reverse().join('');
    },

    back() {
      // Возвращаемся на один шаг назад по ссылке с сохранением состояния
      this.$router.go(-1);
    }
  },
};
</script>

<style scoped>
.Content {
  position: relative;
  display: flex;

  max-width: 720px;
  width: 100%;
  height: fit-content;

  padding-left: 72px;
  padding-right: 72px;

  flex-direction: column;
}
.Title {
  position: relative;
  display: flex;

  width: 100%;
  height: 42px;

  font-family: "Involve";
  font-weight: 600;
  font-size: 32px;
  line-height: 130%;
  align-items: center;
  color: #1a1a1a;

  flex-direction: column;
  align-items: flex-start;
}
.TypeInfo {
  position: relative;
  display: flex;

  width: 100%;
  height: 31px;

  font-family: "Involve";
  font-weight: 500;
  font-size: 24px;
  line-height: 130%;
  align-items: center;
  color: #1a1a1a;

  flex-direction: column;
  align-items: flex-start;

  margin-top: 40px;
}
.Info {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  align-items: flex-start;

  margin-top: 24px;
  gap: 16px;
}

.Info .Module {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: column;
  gap: 16px;
}
.Module .ModuleActions {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  gap: 4px;
}
.ModuleActions .Action {
  position: relative;
  display: flex;

  width: 32px;
  height: 32px;

  box-shadow: 0px 16px 32px -4px rgba(12, 12, 13, 0.1), 0px 4px 4px -4px rgba(12, 12, 13, 0.05);
  border-radius: 8px;

  align-items: center;
  justify-content: center;

  cursor: pointer;
  user-select: none;

  background: #FFFFFF;
  transition: 0.3s;
}
.ModuleActions .Action:hover {
  transition: 0.3s;
  background: #F8F8F8;
}
.ModuleActions .Action:active {
  transition: 0.3s;
  background: #FFFFFF;
}
.ModuleActions .Action img {
  width: 24px;
  height: 24px;
}

.Buttons {
  position: relative;
  display: flex;

  width: 100%;
  height: fit-content;

  flex-direction: row;
  align-items: flex-start;

  margin-top: 40px;
  gap: 8px;
}

.AddButton {
  width: fit-content;
  min-height: 48px;
  height: fit-content;

  padding: 12px 20px;
}
</style>
